<template>
  <div class="upload_box">
    <el-upload
      :action="uploadurl"
      :limit="list.limit ? list.limit : 1"
      :class="
        list.listLengthTag || (list.disabled && list.imglist.length > 0)
          ? 'uplosd_item'
          : ''
      "
      list-type="picture-card"
      :headers="headersobj"
      :disabled="list.disabled"
      :file-list="list.imglist"
      :show-file-list="false"
      :on-change="
        (file, fileList) => {
          changePictureUpload(file, fileList);
        }
      "
      :on-success="
        (response, file, fileList) => {
          handleSuccess(response, file, fileList);
        }
      "
      :on-remove="
        (file, fileList) => {
          handleRemove(file, fileList);
        }
      "
      :before-upload="(file) => beforeAvatarUpload(file, list.prop)"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <div
      v-for="(item, index) in list.imglist"
      :key="index"
      class="img_list_box"
    >
      <el-image
        v-if="
          item.response &&
          $self.pdimg($self.imglisturl(item.response.data.url)) == 'img'
        "
        class="image_box"
        :src="$self.imglisturl(item.response.data.url)"
        :preview-src-list="[$self.imglisturl(item.response.data.url)]"
      >
        <div class="image_box_x" v-if="!list.disabled">x</div>
      </el-image>
      <el-image
        v-if="item.url && !item.response && $self.pdimg(item.url) == 'img'"
        class="image_box"
        :src="item.url"
        :preview-src-list="[item.url]"
      >
      </el-image>
      <div
        class="file_box"
        v-if="
          item.response &&
          $self.pdimg($self.imglisturl(item.response.data.url)) != 'img'
        "
        @click="look($self.imglisturl(item.response.data.url))"
      >
        点击<br />
        查看
      </div>
      <div
        class="file_box"
        v-if="item.url && !item.response && $self.pdimg(item.url) != 'img'"
        @click="look(item.url)"
      >
        点击<br />
        查看
      </div>
      <div
        class="img_list_box_x"
        @click="del(item, index)"
        v-if="!list.disabled"
      >
        x
      </div>
    </div>
    <!-- <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog> -->
  </div>
</template>
<script>
import env from "@/../env.js";
export default {
  props: {
    list: {
      type: Object,
      default: {},
      required: true,
    },
  },
  data() {
    return {
      fileList: [],

      dialogVisible: false,
      dialogImageUrl: "",

      uploadurl: env.API_BASE_URL + env.API_EXTEN_DURL + env.API_img_DURL,
      headersobj: {
        token: localStorage.getItem("token"),
      },
    };
  },
  mounted() {
    // console.log(this.list.imglist);
    // console.log(env.API_BASE_URL + env.API_EXTEN_DURL
    //   + env.API_img_DURL)
    // this.listLengthTag = this.list[0].imglist.length >= this.limit;
  },
  methods: {
    //文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
    changePictureUpload(file, fileList) {
      // console.log('状态')
      let limit = this.list.limit ? this.list.limit : 1;
      this.$emit(
        "change",
        (this.list.listLengthTag = this.list.imglist.length >= limit)
      );
    },
    /**
     * 删除文件(废弃)
     */
    handleRemove(file, fileList) {
      // let limit = this.list.limit ? this.list.limit : 1;
      // this.$emit(
      //   "splice",
      //   (this.list.imglist = fileList.slice(-1000)),
      //   (this.list.listLengthTag = this.list.imglist.length >= limit)
      // );
    },
    /**
     * 删除文件
     */
    del(e, index) {
      // console.log(index, e, this.list)
      let limit = this.list.limit ? this.list.limit : 1;
      let arr = JSON.parse(JSON.stringify(this.list.imglist));
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].response) {
          if (arr[i].response.data.url == e.response.data.url) {
            arr.splice(i, 1);
            i--;
          }
        } else if (!arr[i].response && arr[i].url) {
          if (arr[i].url == e.url) {
            arr.splice(i, 1);
            i--;
          }
        }
      }
      this.$emit(
        "splice",
        (this.list.imglist = arr),
        (this.list.listLengthTag = this.list.imglist.length >= limit)
      );
    },
    //查看
    look(a) {
      window.open(a);
    },
    /**
     * 上传图片预览(废弃)
     * @param {上传文件被点击方法回调} file
     * @param {当前信息栏的下标} index
     */
    handlePictureCardPreview(file, index) {
      console.log(file);

      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
    },
    /**
     * 上传成功
     * @param {后台返回的参数} response
     * @param {方法本身回调} file
     * @param {文件列表} fileList
     * @param {当前信息栏的下标} index
     */
    handleSuccess(response, file, fileList, index) {
      // console.log(file, fileList);
      // for (let i = 0; i < fileList.length; i++) {
      //   if (fileList[i].name.toLowerCase().endsWith('.pdf')) {
      //     fileList[i].response.data[0]

      //   }
      // }

      this.$emit("add", (this.list.imglist = fileList.slice(-1000)));
    },
    /**
     *文件格式限制
     * @param {方法本身回调} file
     * @param {当前信息栏的下标} index
     * @param {Array} format 类型数组存在默认值
     * @param {object} size 文件大小区间
     */

    beforeAvatarUpload(file, prop) {
      // console.log(prop);
      const typeArry =
        prop && prop.format
          ? prop.format
          : [".jpg", ".png", ".JPG", ".PNG", ".jpeg", ".ico", ".pdf", ".zip", ".7z"];

      const type = file.name.substring(file.name.lastIndexOf("."));
      console.log(type, typeArry);
      const isImage = typeArry.indexOf(type) > -1;

      if (!isImage) {
        const typetext = typeArry.join(" 、 ");
        this.$message.error("请上传" + typetext + "格式的文件");
        return isImage;
      }

      if (prop && prop.size) {
        const sizelist = prop.size;
        // console.log(sizelist);

        // console.log(0 < file.size / 1024 / 1024 < sizelist.max);
        const min = sizelist.min ? sizelist.min : 0;
        const max = sizelist.max ? sizelist.max : 100;
        // console.log(min, max);
        let isLt2Mmin = min < file.size / 1024 / 1024;
        let isLt2Mmax = max > file.size / 1024 / 1024;

        // console.log(isLt2Mmin);
        if (!isLt2Mmin || !isLt2Mmax) {
          if (sizelist.min && sizelist.max) {
            this.$message.error(
              "文件大小 " + min + "M - " + sizelist.max + "M"
            );
          }
          if (sizelist.min && !sizelist.max) {
            this.$message.error("文件不小于 " + sizelist.min + "M");
          }
          if (!sizelist.min && sizelist.max) {
            this.$message.error("文件不大于 " + sizelist.max + "M");
          }
          return !isLt2Mmin || isLt2Mmax;
        }
      }
    },
    //  ==
  },
};
</script>


<style scoped>
.upload_box {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.image_box {
  width: 70px;
  height: 70px;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
}

.image_box img {
  width: 100%;
  height: 100%;
}

.file_box {
  width: 70px;
  height: 70px;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  background: #f2f2f2;
  color: #585a5f;
}

.upload_box div:first-child {
  margin-right: 15px;
}

/*去除upload组件过渡效果,回显抖动*/
::v-deep .el-upload-list__item {
  transition: none !important;
}

.uplosd_item ::v-deep.el-upload--picture-card {
  display: none;
}

::v-deep.el-upload-list__item {
  transition: none !important;
  -webkit-transition: nonne !important;
}

::v-deep.el-upload-list__item-name {
  transition: none !important;
  -webkit-transition: nonne !important;
}

.img_list_box {
  position: relative;
}

.img_list_box_x {
  position: absolute;
  top: -4%;
  right: 7%;
  color: red;
  cursor: pointer;
}

.img_list_box_x {
  position: absolute;
  top: -4%;
  right: 23%;
  color: red;
  cursor: pointer;
}
</style>
